module.exports = __webpack_public_path__ + "img/reimbursement.2694b9a9.svg";